import { lazyLoad } from 'site-modules/shared/components/lazy-load/lazy-load';

export const MultiDigitalRetailOfferTypeSrpUsedAsync = lazyLoad({
  loader: () =>
    import(
      /* webpackChunkName: "multi-digital-retail-offer-type-srp-used" */ './multi-digital-retail-offer-type-srp-used'
    ),
  componentName: 'MultiDigitalRetailOfferTypeSrpUsed',
});
